module.exports = __webpack_public_path__ + "bcb3ebe0bab398432b1340520d781e98.pdf";